<template>
  <administrators-list
    v-if="selectedMsp.id"
    :tier="tierType"
    :id="selectedMsp.id"
  />
</template>
<script>
import { mapActions, mapGetters } from "vuex";

import AdministratorsList from "@/views/Common/Administrators/index.vue";

import { TIER } from "@/constants";

export default {
  components: {
    AdministratorsList,
  },
  data() {
    return {
      tierType: TIER.msps,
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  computed: {
    ...mapGetters("authentication", ["selectedMsp"]),
  },
  created() {
    this.setPageTitle();
    this.setPageTitle(this.$t("Administrators"));
    this.setPageSubtitle([]);
  },
};
</script>
